export default "__VITE_ASSET__ZWIRP6Ts__"